import { ResourceView } from "@ra-data-prisma/dataprovider";
import { gql } from "@apollo/client";

const OrderFragment = gql`
  fragment OrderFragment on Order {
    caveats {
      id
      name
      note
      createdAt
      createdBy
    }
    orderTrips {
      id
      locationId
      date
      note
      tripType
      orderNumber
    }
    deliveryNotes {
      id
      deliveryNoteNumber
      currency
      cash
      note
      numberOfItems
      numberOfHalfPallets
      numberOfPackages
      numberOfRequiredSscc
      locationId
      sscc {
        id
        sscc
      }
      loadingUnits {
        id
        typeId
        amount
      }
    }
    user {
      id
      email
      firstName
      lastName
    }
  }
`;

export const OrderResource: ResourceView = {
  resource: "Order",
  fragment: {
    one: {
      type: "document",
      mode: "extend",
      doc: OrderFragment,
    },
    many: {
      type: "document",
      mode: "extend",
      doc: OrderFragment,
    },
  },
};
